<!-- @format -->

<button
	hmf-button
	class="add-to-list-button hmf-sharp-radius hmf-text-align-center hmf-py-xxs hmf-py-md-m hmf-px-md-s"
	[class.icon-filled]="productIsFavorited()"
	variant="secondary"
	[loading]="false"
	[disabled]="actionInProgress()"
	[label]="productIsFavorited() ? 'Delete product from list' : 'Add product to list'"
	[icon]="productIsFavorited() ? FavoritesIconEnum.FILLED : FavoritesIconEnum.OUTLINED"
	size="medium"
	(click)="iconClicked()">
	{{ productIsFavorited() ? 'Added to List' : 'Add to List' }}
</button>
